import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, STORE_SLUG } from "../lib/api";
import { Heart } from "lucide-react";

const LOGO = "https://customer-assets-0z36b82j.emergentagent.net/job_gray-spirit-gear/artifacts/qoih72dz_glogo.jpeg";

export default function GameDay() {
  const [products, setProducts] = useState([]);
  const [store, setStore] = useState(null);

  useEffect(() => {
    api.get(`/stores/${STORE_SLUG}/products`, { params: { popular: true } }).then((r) => setProducts(r.data));
    api.get(`/stores/${STORE_SLUG}`).then((r) => setStore(r.data));
  }, []);
  const priceFrom = store?.pricing?.front_only ?? 25;

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <div className="max-w-2xl mx-auto px-4 py-8">
        <div className="text-center mb-6">
          <div className="flex items-center justify-center mb-4">
            <div className="w-24 h-24 rounded-full bg-white flex items-center justify-center ring-4 ring-[var(--gv-blue)] shadow-[0_0_40px_rgba(242,183,5,0.4)]">
              <img src={LOGO} alt="Gray War Eagles" className="w-20 h-20 object-contain rounded-full" />
            </div>
          </div>
          <h1 className="font-display text-6xl leading-[0.9]" data-testid="gameday-heading">GRAY VOLLEYBALL<br /><span className="text-[var(--gv-blue-bright)]">GEAR</span></h1>
          <p className="mt-3 text-gray-300 uppercase tracking-widest text-sm font-bold">Shop Official Gray Volleyball Spirit Wear</p>
          <p className="mt-1 text-xs uppercase tracking-[0.25em] text-[var(--gv-blue-bright)] font-bold">Gray Collegiate Academy • War Eagles</p>
        </div>

        <div className="bg-[var(--gv-blue)] text-black flex items-center justify-center gap-2 py-3 px-4 mb-6 text-center">
          <Heart className="w-4 h-4" fill="black" />
          <p className="text-xs sm:text-sm font-bold">15% of every sale supports the Gray Volleyball program.</p>
        </div>

        <div className="space-y-4" data-testid="gameday-products">
          {products.map((p) => (
            <div key={p.id} className="flex gap-4 border border-white/10 bg-[#141518] p-3">
              <img src={p.front_image} alt={p.name} className="w-24 h-24 object-cover bg-black flex-shrink-0" />
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="font-bold text-base leading-tight">{p.name}</h3>
                  <p className="text-sm text-[var(--gv-blue-bright)] font-bold mt-1">From ${priceFrom}</p>
                </div>
                <div className="flex gap-2 mt-2">
                  <Link to={`/product/${p.id}`} data-testid={`gameday-buy-${p.id}`}
                    className="flex-1 text-center bg-[var(--gv-blue)] hover:bg-[var(--gv-blue-bright)] text-black text-xs uppercase tracking-widest font-bold py-3 transition-colors">Buy</Link>
                  <Link to={`/product/${p.id}`}
                    className="flex-1 text-center border border-white/20 text-white text-xs uppercase tracking-widest font-bold py-3">Customize</Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link to="/shop/shop-all" className="text-sm uppercase tracking-widest text-gray-400">Browse full store →</Link>
          <p className="mt-6 text-xs text-gray-500">Official team store powered by <span className="text-white font-bold">Dad Jerzeys</span></p>
        </div>
      </div>
    </div>
  );
}
